var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgDogPoop = function SvgSvgDogPoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.75 16h-3a3 3 0 0 0 0 6h16.5a3 3 0 0 0 0-6h-3M6 16a3 3 0 0 1 0-6h2.625a2.625 2.625 0 0 1 0-5.25h4.125a3 3 0 0 0 3-3A3.75 3.75 0 0 1 19.5 5.5 4.5 4.5 0 0 1 15 10h3a3 3 0 0 1 0 6"
  })));
};
export default SvgSvgDogPoop;